import React from 'react'
import { StudentActivitiesList } from '../ActivitiesAwards/StudentActivitiesList'

const ActivitiesProfile = ({ studentId }) => {
	return (
		<div className="card mb-4 shadow-sm" style={{ borderRadius: '8px' }}>
			<div className="card-header border-bottom">
				<h5 className="mb-0">Student Activity</h5>
			</div>
			<div className="card-body p-0">
				<StudentActivitiesList studentId={studentId} isStudentView={true} isProfile={true} />
			</div>
		</div>
	)
}

export { ActivitiesProfile }
